App.ElasticubesTable = class extends App.DataTable {
  constructor(table) {
    const dataSourceUrl = '/sisense/elasticubes/data_table';

    const columns = [
      {
        sortable: false,
        render: function(data, type, full, meta) {
          return '<a href="' + full.edit_link + '" class="btn btn-xs btn-muted-blue">Edit</a>';
        },
        width: '48px'
      },

      {
        data: 'name',
        className: 'all',
        width: '120px'
      },

      {
        data: 'strategy',
        className: 'all',
        width: '120px'
      },

      {
        sortable: false,
        render: function(data, type, full, meta) {
          return full.delete_link
        },
        width: '48px'
      }
    ]

    const noData = '<span class="fa fa-info-sign"></span><p>No elasticubes configured.</p>';

    super({ table: table, dataSourceUrl: dataSourceUrl, columns: columns, noData: noData })
  }
}

$(document).on('turbo:load', function() {
  if($(".elasticubes.index").length == 0) return;

  let elasticubesTable = new App.ElasticubesTable($("table#elasticubes"));
  elasticubesTable.render();
});
